import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, USERS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'allUser',
  url: `${USERS_URL}/all`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
